export default {
  VAT: 'APPLICATION_FORM_PACKAGE_PRICE_TERM_VAT',
  GOODS_AND_SERVICE_TAX: 'APPLICATION_FORM_PACKAGE_PRICE_TERM_GOODS_AND_SERVICE_TAX',
  SALES_TAX: 'APPLICATION_FORM_PACKAGE_PRICE_TERM_SALES_TAX'
}
